<template>
  <div>
    <metho-desc @methodOne="methodTwo('one')">ボタン1</metho-desc>
    <metho-desc @methodOne="methodTwo('two')">ボタン1</metho-desc>
    <metho-desc @methodOne="methodTwo('tree')">ボタン1</metho-desc>

    <!-- <metho-desc @methodOne="methodTwoThree">ボタン2</metho-desc>
    <metho-desc @methodOne="methodTwoFour">ボタン3</metho-desc> -->
    
  </div>
</template>

<script>
import MethoDesc from './MethoDescendant.vue'
export default {
  components:{
    MethoDesc
  },
  data(){
   return{
     obj:{
       msg1:'1st msg',
       msg2:'2nd msg',
       msg3:'3rd msg'
     }
   }
  },
  methods:{
    // methodTwo: function(){
    //   return this.$emit('methodTwo');
    // },
    // methodTwoThree: function(){
    //   return this.$emit('methodTwoThree');
    // },
    // methodTwoFour: function(){
    //   return this.$emit('methodTwoFour');
    // }
    methodTwo(n) {
      this.$emit(n,this.obj);
      console.log(this.obj);
    }
  }
}
</script>
<style scoped>

</style>